export class ProductInformation {
  transportInformationId: number;
  compartmentNumber: number;
  compartmentCapacity: number;
  previousProduct1: string;
  previousProduct2: string;
  previousProduct3: string;
  idtF1: string;
  idtF2: string;
  idtF3: string;

  constructor() {
    this.transportInformationId = null;
    this.compartmentNumber = null;
    this.compartmentCapacity = null;
    this.previousProduct1 = null;
    this.previousProduct2 = null;
    this.previousProduct3 = null;
    this.idtF1 = null;
    this.idtF2 = null;
    this.idtF3 = null;
  }
}
